import { ClassNameProps, makeClassName, Row, StyleProps } from "@hex-insights/core";
import { Badge } from "../../../../Components/Badge";
import { Icon } from "../../../../Components/Icon";
import { ModelUtilities } from "../../../Utilities";
import styles from "./styles.module.css";

export const paymentStatusColors = {
	[ModelUtilities.PaymentStatus.Paid]: {
		color: "var(--theme-colors__green--dark)",
		backgroundColor: "var(--theme-colors__green--very-light)",
		iconColor: "var(--theme-colors__green)",
	},
	[ModelUtilities.PaymentStatus.Overdue]: {
		color: "var(--theme-colors__orange--dark)",
		backgroundColor: "var(--theme-colors__orange--very-light)",
		iconColor: "var(--theme-colors__orange)",
	},
	[ModelUtilities.PaymentStatus.Due]: {
		color: "var(--theme-colors__yellow--dark)",
		backgroundColor: "var(--theme-colors__yellow--very-light)",
		iconColor: "var(--theme-colors__yellow)",
	},
	[ModelUtilities.PaymentStatus.Upcoming]: {
		color: "var(--neutral-colors--tertiary)",
		backgroundColor: "var(--neutral-colors--light)",
		iconColor: "var(--neutral-colors--tertiary)",
	},
};

export type PaymentStatusBadgeProps = {
	status: ModelUtilities.PaymentStatus;
	withIcon?: boolean;
} & Partial<ClassNameProps & StyleProps>;

export function PaymentStatusBadge({ status, withIcon = false, className, style }: PaymentStatusBadgeProps) {
	const colors = paymentStatusColors[status];

	return (
		<Badge
			color={colors.color}
			backgroundColor={colors.backgroundColor}
			className={makeClassName(styles["payment-status-badge"], className)}
			style={style}
		>
			<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
				{withIcon && <PaymentStatusIcon status={status} size={14} color={colors.color} />} {status}
			</Row>
		</Badge>
	);
}

export type PaymentStatusIconProps = Icon.IconProps & {
	status: ModelUtilities.PaymentStatus;
};

export function PaymentStatusIcon({ status, color, ...props }: PaymentStatusIconProps) {
	color = color ?? paymentStatusColors[status].iconColor;

	switch (status) {
		case ModelUtilities.PaymentStatus.Paid:
			return <Icon.CheckCircle color={color} {...props} />;
		case ModelUtilities.PaymentStatus.Overdue:
			return <Icon.WarningCircle color={color} {...props} />;
		case ModelUtilities.PaymentStatus.Due:
			return <Icon.Clock color={color} {...props} />;
		case ModelUtilities.PaymentStatus.Upcoming:
			return <Icon.ClockClockwise color={color} {...props} />;
	}
}
